import { getApp as getPublicApp, getApps as getPublicApps } from './apps'

const appKey = 'apps'
const keys = {
  list: [appKey, 'list'],
  details: [appKey, 'details']
}

export const getApps = () => ({
  mutationKey: keys.list,
  queryFn: getPublicApps
})

export const getApp = (id) => ({
  queryKey: [...keys.details, id],
  queryFn: () => getPublicApp(id),
  enabled: Boolean(id)
})
